// Post.jsx
import React from "react";
import styles from "./Content.module.css"; // Import CSS module

const Post = ({ post, handleBookmark, handleRemoveBookmark, handleRemove }) => {
  return (
    <div className={styles.postContainer}>
      <h2 className={styles.postTitle}>{post.title}</h2>
      {post.image_url && (
        <img
          className={styles.postImage}
          src={post.image_url}
          alt={post.title}
        />
      )}
      <div
        className={styles.postBody}
        dangerouslySetInnerHTML={{ __html: post.description }}
      ></div>
      <button
        className={`${styles.button} ${styles.bookmarkButton}`}
        onClick={() => handleBookmark(post)}
      >
        Bookmark
      </button>
      <button
        className={`${styles.button} ${styles.removeButton}`}
        onClick={() => handleRemove(post)}
      >
        Remove
      </button>
    </div>
  );
};

export default Post;
